import * as yup from 'yup';
import { yupUtils } from '../../utils/yup/utils';

export const SectionSchema = yup.object().shape({
  type: yupUtils.stringRequired('Section type is required'),
  title: yupUtils.stringOptionalNullable,
  style: yupUtils.stringOptionalNullable,
  sectionVisibleItems: yupUtils.numberOptionalNullable,
  fetchRuleType: yupUtils.stringOptionalNullable,
  fetchRuleCategory: yup.string().when('fetchRuleType', {
    is: 'category',
    then: yupUtils.stringRequired('Category is required'),
    otherwise: yupUtils.stringOptionalNullable,
  }),
  fetchRulePillarType: yup.string().when('fetchRuleType', {
    is: 'pillar',
    then: yupUtils.stringRequired('Pillar type is required'),
    otherwise: yupUtils.stringOptionalNullable,
  }),
  placeholderText: yupUtils.stringOptionalNullable,
  forceSeeAll: yupUtils.booleanOptionalNullable,
  isTestingSection: yupUtils.booleanOptionalNullable,
  removeFromSale: yupUtils.booleanOptionalNullable,
  showInLoop: yupUtils.booleanOptionalNullable,
  showAuthorCategoriesOrderTab: yupUtils.booleanOptionalNullable,
  description: yupUtils.stringOptionalNullable,
  tags: yup.array().of(yup.string()).nullable(),
});
